import { ChangeDetectorRef, Component, ElementRef, EventEmitter,
  Input,
  OnChanges, OnInit, Output, SimpleChanges, ViewRef } from '@angular/core';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import * as moment from 'moment';
import { ApiService } from '../../../@core/service/api.service';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { UserModel, BusinessModel, BusinessUnitModel } from '../../../@models';
import { CompilationModel } from '../../../@models/erp/compilation';
import { CompilationTypeData, ImporterData } from '../../../@models/erp/compilationData';
import { CommonPrinter } from '../../erp/reports/reports-printer/commonPrinter';
import { IPopupReport } from '../../erp/reports/reports-printer/reports-printer.component';
import { ReportsComponent } from '../../erp/reports/reports.component';


export enum ChartType {
  turnover = 1,
  customer = 2,
}

@Component({
  selector: 'ngx-dashboard-renderer',
  templateUrl: './renderer.component.html',
  styleUrls: ['./renderer.component.scss'],
})
export class DashboardRendererComponent extends CommonPrinter implements OnInit, OnChanges {
  @Input() search: any;
  @Input() pdfSidebar: boolean = true;
  @Input() users: UserModel[];
  @Input() reportData: any ={};
  @Input() compilation: CompilationModel;
  // @Input() businesses: BusinessModel[];
  // @Input() businessUnits: BusinessUnitModel[];
  @Output() done = new EventEmitter<string>();
  @Output() back = new EventEmitter<void>();

  pdfData: any;
  totalCount: any;

  // user: UserModel;

  // users: UserModel[];
  // businesses: BusinessModel[];
  // businessUnits: BusinessUnitModel[];

  // search = {
  //   customeroverview: {
  //     orientation: 'portrait',
  //     // dateType: DateSelectionData.currentYear.id,
  //     manager: null,
  //     issuer: null,
  //     country: null,
  //     dateFrom: new Date(new Date().getFullYear() + '-01-01'),
  //     dateTo: new Date(),
  //     customers: [],
  //     businessUnits: [],
  //     trial: null,
  //     finishedProduct: null,
  //     years: 3,
  //     attachedReports: {
  //       lastinvoices: true,
  //       noninvoiced: true,
  //       dueinvoices: true,
  //       srpfin: true,
  //       srnoninvoiced: true,
  //     },
  //     limit: 5,
  //   },
  // }

  chartType: ChartType;
  attachedReports: any = [];

  showCharts = false;
  chartsLoaded = false;

  showPopupReport = false;

  pageLinkEnabled: any = {};

  constructor(private elRef: ElementRef, private api: ApiService, public auth: AuthGuardService,
    public data: SharedDataService, private cdRef: ChangeDetectorRef, private router: Router, private toastr: NbToastrService) {

    super(elRef, api, auth, data);
  }

  async ngOnInit() {
    super.init();

    this.data.loadUsers();

    this.reloadData();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.search && changes.search.currentValue && !changes.search.firstChange) {
      this.reloadData();
    }
  }

  async reloadData() {

    // console.log('===>reload data')

    // TODO: improve performance, use only one api call
    if (!this.search) {
      this.done.emit();
      return;
    }
    const type = this.getType();
    this.query = this.search[type];
    if (this.search[type] && this.search[type].dateFrom) {
      this.search[type].dateFrom.setHours(2);
      this.search[type].dateFrom.setMinutes(0);
      this.search[type].dateFrom.setSeconds(0);
    }
    if (this.search[type] && this.search[type].dateTo) {
      this.search[type].dateTo.setHours(23);
      this.search[type].dateTo.setMinutes(59);
      this.search[type].dateTo.setSeconds(59);
    }

    // if (this.showCharts) {
    //   // this.pdfData = await this.api.getDocumentReportAsync(type, this.search, true);
    //   this.pdfData = await this.api.getDocumentReportAsync2(type, this.search, true);

    //   console.log('pdfData2?.tables?.thisMonth', this.pdfData, this.pdfData?.charts, this.pdfData?.tables)
    //   this.chartsLoaded = true;
    // }
    if (this.showCharts) this.reloadCharts();

    this.attachedReports = this.getAttachedReports();

    this.loading = false;
    if (this.cdRef && !(this.cdRef as ViewRef).destroyed) this.cdRef.detectChanges();
    this.done.emit();
  }

  async reloadCharts() {
      const type = this.getType();
      // this.pdfData = await this.api.getDocumentReportAsync(type, this.search, true);
      this.pdfData = await this.api.getDocumentReportAsync2(type, this.search, true);

      console.log('pdfData2?.tables?.thisMonth', this.pdfData, this.pdfData?.charts, this.pdfData?.tables)
      this.chartsLoaded = true;
  }

  showChart(chart: string) {
    const type = this.getType();
    // console.log('~~~~~~~~~~~~~~~~~>chart', chart, this.pdfData.charts[chart])
    switch (chart) {
      case 'yearChart':
        if (!this.search[type] || !this.search[type].dateFrom || !this.search[type].dateFrom.toISOString()) return true;
        return !(this.search[type].dateFrom.toISOString().match(/\d\d\d\d-01-01/)
          && this.search[type].dateTo.toISOString().match(/\d\d\d\d-12-31/))
      default:
        return this.pdfData.charts[chart] != null;
    }
  }

  getAttachedReports() {
    const search = this.search.customeroverview;
    const reports = [];
    const tmp = [];

    for (let r in search.attachedReports) {
      if (search.attachedReports[r].show === true) {
        const params: any = {};

        let sr = false;
        if (r === 'srpfin') {
          sr = true;
          r = 'lastinvoices';
        } else if ( r === 'srnoninvoiced') {
          sr = true;
          r = 'noninvoiced';
        }

        const report = ReportsComponent.defaultReport[r];

        params[r] = JSON.parse(JSON.stringify(report));
        params[r].issuer = search.issuer;
        params[r].customers = search.customers;
        params[r].finishedProducts = search.finishedProducts;
        params[r].customerDocumentNumbers = search.customerDocumentNumbers;
        params[r].manager = search.manager;
        params[r].filterInternal = true;
        params[r].offset = search.attachedReports[r].offset;
        params[r].limit = search.attachedReports[r].showAll ? undefined : search.attachedReports[r].limit;
        params[r].country = search.country;
        if (search.sampleRequest > 0) params[r].sampleRequest = search.sampleRequest;
        params[r].dateFrom = new Date('2016-01-01');
        switch(r) {
          case 'lastinvoices':
            params[r].businessUnits = search.businessUnits;
            params[r].finishedProduct = search.finishedProduct;
            if (search.dateSelection > 1) {
              params[r].dateFrom = search.dateFrom;
            }
            params[r].dateTo = search.dateTo;
            params[r].docs = sr ?
              { in: true, pfin: true, cn: false, pfcn: false }
              : { in: true, pfin: false, cn: true, pfcn: false };
            params[r].sampleRequest = (search.sampleRequest > 0) ? search.sampleRequest : (sr ? 2 : 3);
            break;
          case 'noninvoiced':
            params[r].businessUnits = search.businessUnits;
            params[r].finishedProduct = search.finishedProduct;
            if (search.dateSelection > 1) {
              params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            } else {
              params[r].dateTo = null;
            }
            params[r].sampleRequest = (search.sampleRequest > 0) ? search.sampleRequest : (sr ? 2 : 3);
            params[r].sortType = 3 // sort by next invoice date
            break;
          case 'dueinvoices':
            if (search.dateSelection > 1) {
              params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            } else {
              // params[r].dateFrom = null;
              params[r].dateTo = null;
            }
            break;
          case 'offers':
            params[r].businessUnits = search.businessUnits;
            params[r].finishedProduct = search.finishedProduct;
            params[r].offerStatus = [ true, true, true, true, true, true ];
            if (search.dateSelection > 1) {
              params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            } else {
              // params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            }
            break;
          case 'orders':
            params[r].businessUnits = search.businessUnits;
            params[r].finishedProduct = search.finishedProduct;
            params[r].relatedOcs = 1; // 1 = none, 2 = all, 3 = non invoiced
            params[r].relatedInvoices = 1; // 1 = not paid, 2 = partially paid, 3 = fully paid
            params[r].relatedCreditNotes = 1; // 1 = none 2 = all
            params[r].relatedSPOs = search.relatedSPOs;
            params[r].showMarkup = search.showMarkup;
            if (search.dateSelection > 1) {
              params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            } else {
              // params[r].dateFrom = search.dateFrom;
              params[r].dateTo = search.dateTo;
            }
            break;
        }
        tmp.push({r, params});

      }
    }

    for (const type of search.sort) {
      const rep = tmp.find(t => type === t.r
        || (type === 'srpfin' && t.r === 'lastinvoices' && t.params.lastinvoices.sampleRequest === 2)
        || (type === 'srnoninvoiced' && t.r === 'noninvoiced' && t.params.noninvoiced.sampleRequest === 2));
      rep && reports.push(rep.params);
    }

    // console.log('search', search, reports);

    return reports;

  }

  // getAttachedReports() {
  //   const search = this.search.customeroverview;
  //   const reports = [];
  //   const tmp = [];

  //   for (let r in search.attachedReports) {
  //     if (search.attachedReports[r] === true) {
  //       const params: any = {};

  //       let sr = false;
  //       if (r === 'srpfin') {
  //         sr = true;
  //         r = 'lastinvoices';
  //       } else if ( r === 'srnoninvoiced') {
  //         sr = true;
  //         r = 'noninvoiced';
  //       }
  //       const report = ReportsComponent.defaultReport[r];

  //       params[r] = JSON.parse(JSON.stringify(report));
  //       params[r].issuer = search.issuer;
  //       params[r].customers = search.customers;
  //       params[r].manager = search.manager;
  //       params[r].filterInternal = true;
  //       switch(r) {
  //         case 'lastinvoices':
  //           params[r].businessUnits = search.businessUnits;
  //           params[r].finishedProduct = search.finishedProduct;
  //           params[r].dateFrom = search.dateFrom;
  //           params[r].dateTo = search.dateTo;
  //           params[r].docs = sr ?
  //             { in: true, pfin: true, cn: false, pfcn: false }
  //             : { in: true, pfin: false, cn: true, pfcn: false };
  //           params[r].sampleRequest = sr ? 2 : 3;
  //           params[r].limit = 5;
  //           break;
  //         case 'noninvoiced':
  //           params[r].businessUnits = search.businessUnits;
  //           params[r].finishedProduct = search.finishedProduct;
  //           params[r].dateFrom = null;
  //           params[r].dateTo = null;
  //           params[r].sampleRequest = sr ? 2 : 3;
  //           params[r].limit = 5;
  //           break;
  //         case 'dueinvoices':
  //           params[r].dateFrom = null;
  //           params[r].dateTo = null;
  //           params[r].limit = 5;
  //           break;
  //         case 'offers':
  //           params[r].businessUnits = search.businessUnits;
  //           params[r].finishedProduct = search.finishedProduct;
  //           params[r].offerStatus = [ true, true, true, true, true, true ];
  //           params[r].dateFrom = search.dateFrom;
  //           params[r].dateTo = search.dateTo;
  //           params[r].limit = 5;
  //           break;
  //         case 'orders':
  //           params[r].businessUnits = search.businessUnits;
  //           params[r].finishedProduct = search.finishedProduct;
  //           params[r].relatedOcs = 1; // 1 = none, 2 = all, 3 = non invoiced
  //           params[r].relatedInvoices = 1; // 1 = not paid, 2 = partially paid, 3 = fully paid
  //           params[r].relatedCreditNotes = 1; // 1 = none 2 = all
  //           params[r].dateFrom = search.dateFrom;
  //           params[r].dateTo = search.dateTo;
  //           params[r].limit = 5;
  //           break;
  //       }
  //       tmp.push({r, params});
  //     }
  //   }

  //   for (const type of search.sort) {
  //     const rep = tmp.find(t => type === t.r
  //       || (type === 'srpfin' && t.r === 'lastinvoices' && t.params.lastinvoices.sampleRequest === 2)
  //       || (type === 'srnoninvoiced' && t.r === 'noninvoiced' && t.params.noninvoiced.sampleRequest === 2));
  //     rep && reports.push(rep.params);
  //   }

  //   return reports;
  // }

  getDateInterval() {
    const type = this.getType();
    const from =  moment(this.search[type].dateFrom).format('yyyy-MM-DD');
    const to =  moment(this.search[type].dateTo).format('yyyy-MM-DD');
    return `(${from} - ${to})`;
  }

  getPageLink(params) {
    if (params.lastinvoices && params.lastinvoices.sampleRequest === 2) {
      return { id: 'srpfin', title: 'Last sample deliveries' };
    }
    if (params.noninvoiced && params.noninvoiced.sampleRequest === 2) {
      return { id: 'srnoninvoiced', title: 'Upcoming sample deliveries' };
    }
    if (params.lastinvoices) return { id: 'lastinvoices', title: 'Last invoices' };
    if (params.dueinvoices) return { id: 'dueinvoices', title: 'Due invoices' };
    if (params.orders) return { id: 'orders', title: 'Incoming orders' };
    if (params.noninvoiced) return { id: 'noninvoiced', title: 'Upcoming deliveries' };
    if (params.offers) return { id: 'offers', title: 'Last offers' };
    return { id: '', title: '' };
  }

  rep(params) {
    if (!this.query) return {} as any;
    for (const i in this.query.attachedReports) {
      if (params[i]) return params[i];
    }
    return {} as any;
  }

  scroll(id: string) {
    const el = document.getElementById(id)
    if (id === 'top') {
      el.parentElement.parentNode.parentElement.scrollIntoView();
    } else {
      el.scrollIntoView();
    }
  }

  reportLoaded(params: string) {
    const lnk = this.getPageLink(params).id;
    const el = document.getElementById('btn-' + lnk);
    if (el) (el as any).disabled = false;
  }

  async onPopupReport(reportData: IPopupReport) {
    const searches = [];
    if (!reportData.docs || !reportData.docs[0]) {
      this.toastr.info('', 'no related order');
      return;
    }
    for (const doc of reportData.docs) {
      const search = { orders: Object.assign({}, ReportsComponent.defaultReport.orders) };
      search.orders.order = doc.code;
      search.orders.relatedOcs = 2;
      search.orders.relatedInvoices = 2;
      search.orders.relatedCreditNotes = 2;
      search.orders.relatedSPOs = this.search.customeroverview.relatedSPOs;
      search.orders.showMarkup = this.search.customeroverview.showMarkup;
      searches.push(search);
      this.reportData = searches;
    }
    this.showPopupReport = true;
  }

}
